import ReactDefaultProps from 'views/main/react/ReactDefaultProps';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from 'config/queryClient';

var ReactComponentView = function() {
    this.element = null;
};

/**
 * Renders the given react component in the given DOM element
 * @param component - The react global component to render
 * @param el - the DOM element to render in
 * @param args - any arguments that will be passed as props into the React component
 */
ReactComponentView.prototype.renderComponent = function(component, el, args) {
    // Wrap the page component element in a QueryCientProvider
    args = $.extend(true, {}, ReactDefaultProps, args, { rootElement: el });
    const element = React.createElement(
        QueryClientProvider,
        { client: queryClient },
        React.createElement(component, args)
    );

    this.element = el;

    if (!this.root || this.element !== el) {
        this.root = createRoot(el);
    }
    this.root.render(element);
};

ReactComponentView.prototype.removeComponent = function() {
    if (!this.root) {
        return;
    }
    this.root.unmount(this.element);
};

export default ReactComponentView;
